import styled from 'styled-components'

import { colors } from '../../constants'

export default styled.a`
    ${({ color }) => (color ? `color: ${color};` : `color: ${colors.blue};`)}
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
`
